import { useEffect } from 'react'
import { isEditableInContainer } from '../lib/editorCursorAnchor'

type Props = {
  containerRef: React.RefObject<HTMLElement | null>
  onTrigger: () => void
  disabled?: boolean
}

function charBeforeCaret(): string {
  const sel = window.getSelection()
  if (!sel || sel.rangeCount === 0) return ''
  const range = sel.getRangeAt(0)
  if (!range.collapsed) return ''

  const { startContainer, startOffset } = range
  if (startContainer.nodeType === Node.TEXT_NODE) {
    const text = startContainer.textContent || ''
    if (startOffset > 0) return text[startOffset - 1]
  }

  const probe = range.cloneRange()
  probe.collapse(true)
  if (!probe.startContainer.nodeValue && startOffset === 0) {
    let node: Node | null = startContainer
    while (node) {
      const prev = node.previousSibling
      if (prev) {
        const text = prev.textContent || ''
        if (text) return text[text.length - 1]
        break
      }
      node = node.parentNode
    }
  }
  return ''
}

function deleteCharBeforeCaret(): void {
  const sel = window.getSelection()
  if (!sel || sel.rangeCount === 0) return
  const range = sel.getRangeAt(0)
  if (!range.collapsed) return

  const { startContainer, startOffset } = range
  if (startContainer.nodeType !== Node.TEXT_NODE || startOffset <= 0) return

  const del = document.createRange()
  del.setStart(startContainer, startOffset - 1)
  del.setEnd(startContainer, startOffset)
  del.deleteContents()
}

/** 在正文编辑器内输入 // 唤起光标旁描述意图小对话（不插入 //） */
export function DocEditorAtAiTrigger({ containerRef, onTrigger, disabled }: Props) {
  useEffect(() => {
    const container = containerRef.current
    if (!container || disabled) return

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey || e.isComposing) return
      if (!isEditableInContainer(e.target, container)) return
      if (charBeforeCaret() !== '/') return
      e.preventDefault()
      e.stopPropagation()
      deleteCharBeforeCaret()
      onTrigger()
    }

    container.addEventListener('keydown', onKeyDown, true)
    return () => container.removeEventListener('keydown', onKeyDown, true)
  }, [containerRef, disabled, onTrigger])

  return null
}
